import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { RootState } from 'src/store';
import {
  Application,
  ApplicationSettings,
  GetAdminApplicationsParams,
} from '../types';
import { ApplicationsState } from './types';

const initialState: ApplicationsState = {
  loading: {
    getList: false,
    getById: false,
    getSettingsById: false,
    getSettingsByDomain: false,
    create: false,
    update: false,
  },
  filter: {
    offset: 0,
    limit: 25,
    page: 0,
  },
  list: null,
  selectedApplication: null,
  selectedApplicationSettings: null,
  error: null,
};

const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<Partial<Record<keyof ApplicationsState["loading"], boolean>>>) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetAdminApplicationsParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: Application[];
        count: number;
      }>
    ) => {
      state.list = action.payload;
    },
    setApplication: (state, action: PayloadAction<Application>) => {
      state.selectedApplication = action.payload;
    },
    setApplicationSettings: (state, action: PayloadAction<ApplicationSettings>) => {
      state.selectedApplicationSettings = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: (state) => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetError: (state) => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const isApplicationsLoading = (state: RootState) => state.applications.loading;

export const getApplications = (state: RootState) => state.applications.list;

export const getApplication = (state: RootState) => state.applications.selectedApplication;

export const getApplicationSettings = (state: RootState) => state.applications.selectedApplicationSettings;

export const isApplicationsError = (state: RootState) => state.applications.error;

export const {
  setLoading,
  setFilter,
  setList,
  setApplication,
  setApplicationSettings,
  setError,
  resetList,
  resetError,
  resetSlice,
} = applicationsSlice.actions;

export const applicationsReducer = applicationsSlice.reducer;
